import React from "react";
import classes from "./Spinner.module.scss";

function Spinner() {
  return <div className={classes.spinner} style={{ marginTop: "24px" }}></div>;
}

export default Spinner;
